import { StatesModule } from '@uirouter/angular';
import { GlobalSettingsNavigationTabsComponent } from '@fi-app/global-settings/global-settings-navigation-tabs/global-settings-navigation-tabs.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const GlobalSettingsStates: StatesModule = {
    states: [
        {
            name: FiStateNames.GlobalSettings,
            abstract: true,
            url: '/GlobalSettings',
            component: GlobalSettingsNavigationTabsComponent,
            resolve: {},
        },
    ],
};
